import React, { useEffect, useState } from 'react';
import AffiliateA from 'components/Affiliate/AffiliateA';
import {
  getAffiliate,
  getAffiliateKey,
  setItem,
  removeItem,
} from 'utils/Cookies';
import { getWindowDomain } from 'utils/Window';
import hexToString from 'utils/Hex';
import { loader } from 'graphql.macro';
import { useLazyQuery } from '@apollo/client';

const AFFILIATES_SEARCH_QUERY = loader('./affiliatesSearch.graphql');

const AffiliatesContainer = () => {
  const [firstCookie, setFirstCookie] = useState('');
  const [affiliateState, setAffiliateState] = useState();
  const [isOpenState, setIsOpenState] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [encodedSaleCode, setEncodedSaleCode] = useState('');

  useEffect(() => {
    const { affiliate } = getAffiliate();
    setFirstCookie(affiliate);
  }, []);

  const handleVisibility = (hideModal) => {
    setIsOpenState(!hideModal && !firstCookie);
    setIsVisible(!hideModal);
  };

  const isInvalidCookie = (affiliateParam, affiliate) => {
    const result = affiliateParam && (!affiliate || (affiliate !== affiliateParam));
    return result;
  };

  const handleResults = (affiliate) => {
    const {
      title,
      discount,
      topCopy,
      bottomCopy,
      buttonLabel,
      logo,
      saleCode,
      hideModal,
    } = affiliate;

    const {
      displayName,
      isAffiliate,
      company = {},
    } = saleCode ?? {};

    if (!isAffiliate || !title) {
      removeItem(getAffiliateKey());
      setEncodedSaleCode(null);
      return;
    }

    const {
      altText,
      url,
    } = logo ?? {};

    const {
      name: companyName,
    } = company;

    const affiliateObj = {
      saleCode: {
        name: encodedSaleCode,
        displayName,
        isAffiliate,
        company: {
          name: companyName,
        },
      },
      discount,
      buttonLabel,
      topCopy,
      bottomCopy,
      logo: {
        altText,
        url,
      },
      hideModal,
    };
    handleVisibility(hideModal);
    setAffiliateState(affiliateObj);
  };

  const [performSearch, { data, loading, error }] = useLazyQuery(
    AFFILIATES_SEARCH_QUERY,
    {
      onCompleted: () => {
        handleResults({ ...data?.public?.content?.forAffiliate });
      },
    },
  );

  const getAffiliatesInfo = (affiliateCode) => {
    performSearch({
      variables: {
        saleCode: affiliateCode,
      },
    });
  };

  const setCookie = (affiliateCode) => {
    const domain = getWindowDomain();
    setItem(
      getAffiliateKey(),
      {
        affiliate: affiliateCode,
      },
      {
        path: '/',
        expires: 30,
        domain: domain !== 'localhost' && `.${domain}`,
      },
    );
    setEncodedSaleCode(affiliateCode);
  };

  const getUrlParameters = () => {
    let affiliateParam;
    if (typeof window !== 'undefined') {
      if ('URLSearchParams' in window) {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('affiliate')) {
          affiliateParam = searchParams.get('affiliate');
        }
      }
    }
    return affiliateParam;
  };

  const getAffiliateCode = () => {
    // Get by querystring
    const affiliateUrl = getUrlParameters();
    // Get by Cookie
    const { affiliate: affiliateCookie } = getAffiliate();

    return affiliateUrl ?? affiliateCookie;
  };

  useEffect(() => {
    const affiliateParam = getAffiliateCode();

    if (affiliateParam) {
      getAffiliatesInfo(hexToString(affiliateParam));

      // Checks if the current cookie is different of the affiliate parameter
      if (isInvalidCookie(affiliateParam, firstCookie)) {
        setCookie(affiliateParam);
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    (encodedSaleCode && isVisible &&
      <AffiliateA
        loading={loading}
        error={(error && error.message)}
        {...affiliateState}
        onClose={() => setIsOpenState(false)}
        onOpen={() => {
          if (!affiliateState) {
            getAffiliatesInfo(hexToString(encodedSaleCode));
          }
          setIsOpenState(true);
        }}
        isOpen={isOpenState}
      />)
    || null
  );
};

export default AffiliatesContainer;
